import React, { useState } from 'react';

import type { ViewMoreModalParams } from './ViewMoreModalParams';
import { ViewMoreModalParamsContext } from './ViewMoreModalParamsContext';

export const ViewMoreModalParamsProvider = ({
	children,
	surface,
}: {
	children: React.ReactNode;
	/** Which product surface opened the modal (e.g. 'chat', 'search') — merged into params automatically */
	surface?: string;
}): React.JSX.Element => {
	const [params, setParams] = useState<ViewMoreModalParams | null>(null);
	const mergedParams = React.useMemo<ViewMoreModalParams | null>(
		() => (params ? { ...params, surface: params.surface ?? surface } : null),
		[params, surface],
	);
	const value = React.useMemo(() => ({ params: mergedParams, setParams }), [mergedParams]);
	return (
		<ViewMoreModalParamsContext.Provider value={value}>
			{children}
		</ViewMoreModalParamsContext.Provider>
	);
};
